import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-213d5654"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "statistics_view_title" }, "Statistiques :", -1))
const _hoisted_2 = { id: "select_periods" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sélectionner une date :", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "start_period_date" }, "Du ", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end_period_date" }, " au ", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { id: "select_sellers_popup" }
const _hoisted_9 = {
  key: 0,
  class: "popup_overlay"
}
const _hoisted_10 = { class: "popup" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Liste des commerçants", -1))
const _hoisted_12 = { id: "checkall_checkbox" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkAll" }, "Tout sélectionner", -1))
const _hoisted_14 = { class: "popup-content" }
const _hoisted_15 = { class: "seller-list" }
const _hoisted_16 = ["id", "value", "onUpdate:modelValue", "checked", "onChange"]
const _hoisted_17 = ["for"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "popup-button-container" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "charts" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "charts" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "charts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavView = _resolveComponent("NavView")!
  const _component_feesBarChart = _resolveComponent("feesBarChart")!
  const _component_feesLineChart = _resolveComponent("feesLineChart")!
  const _component_soluliveFeesBarChart = _resolveComponent("soluliveFeesBarChart")!
  const _component_soluliveFeesLineChart = _resolveComponent("soluliveFeesLineChart")!
  const _component_soluliveGrossMarginBarChart = _resolveComponent("soluliveGrossMarginBarChart")!
  const _component_soluliveGrossMarginLineChart = _resolveComponent("soluliveGrossMarginLineChart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavView),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("input", {
        type: "date",
        name: "start_period_date",
        id: "start_period_date",
        min: "2021-01-01",
        max: "2050-12-31",
        value: _ctx.startPeriodDate
      }, null, 8, _hoisted_5),
      _hoisted_6,
      _createElementVNode("input", {
        type: "date",
        name: "end_period_date",
        id: "end_period_date",
        value: _ctx.endPeriodDate
      }, null, 8, _hoisted_7),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.update_date_filter && _ctx.update_date_filter(...args)))
      }, "Confirmer")
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displaySellersList = !_ctx.displaySellersList))
      }, "filtrer commerçant(s)"),
      (_ctx.displaySellersList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "checkAll",
                  id: "checkAll",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectAll) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateAllCheckedNames && _ctx.updateAllCheckedNames(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.selectAll]
                ]),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sellersList, (seller, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: seller.id
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "checkbox_seller",
                        id: 'checkbox_' +index,
                        value: seller.techName,
                        "onUpdate:modelValue": ($event: any) => ((seller.isChecked) = $event),
                        checked: _ctx.checkedNames.includes(seller.techName),
                        onChange: ($event: any) => (_ctx.updateCheckedNames(seller))
                      }, null, 40, _hoisted_16), [
                        [_vModelCheckbox, seller.isChecked]
                      ]),
                      _createElementVNode("label", {
                        for: 'checkbox_' +index
                      }, _toDisplayString(seller.techName), 9, _hoisted_17),
                      _createTextVNode(),
                      _hoisted_18
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "popup-button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.confirm_seller(); _ctx.displaySellersList = !_ctx.displaySellersList})
                }, "Confirmer")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.feesData && Object.keys(_ctx.feesData).length > 0 && _ctx.displayChart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("p", null, "Total des frais : " + _toDisplayString(_ctx.totalFees) + " €", 1),
          _createElementVNode("p", null, "Total des frais de livraison : " + _toDisplayString(_ctx.totalFeesDelivery) + " €", 1),
          _createElementVNode("p", null, "Total des frais de transactions : " + _toDisplayString(_ctx.totalFeesTransactions) + " €", 1),
          _createElementVNode("p", null, "Total des autres frais : " + _toDisplayString(_ctx.totalFeesOthers) + " €", 1),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_feesBarChart, {
              feesData: _ctx.feesDataForChart,
              ref: "feesBarChart"
            }, null, 8, ["feesData"]),
            _createVNode(_component_feesLineChart, { feesData: _ctx.feesDataForChart }, null, 8, ["feesData"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.feesDataSolulive && Object.keys(_ctx.feesDataSolulive).length > 0 && _ctx.displayChart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("p", null, "Total des frais de Solulive : " + _toDisplayString(_ctx.feesDataSolulive.feesTotalsSolulive.totalFeesSolulive) + " €", 1),
          _createElementVNode("p", null, "Total des frais de livraison de Solulive: " + _toDisplayString(_ctx.feesDataSolulive.feesTotalsSolulive.totalFeesDeliverySolulive) + " €", 1),
          _createElementVNode("p", null, "Total des frais de SendCloud Label de Solulive : " + _toDisplayString(_ctx.feesDataSolulive.feesTotalsSolulive.totalFeesSendCloudLabelSolulive) + " €", 1),
          _createElementVNode("p", null, "Total des frais de SMS de Solulive : " + _toDisplayString(_ctx.feesDataSolulive.feesTotalsSolulive.totalFeesSmsSolulive) + " €", 1),
          _createElementVNode("p", null, "Total des frais de GoCardLess de Solulive : " + _toDisplayString(_ctx.feesDataSolulive.feesTotalsSolulive.totalFeesGoCardLessSolulive) + " €", 1),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_soluliveFeesBarChart, { feesData: _ctx.soluliveFeesDataForChart }, null, 8, ["feesData"]),
            _createVNode(_component_soluliveFeesLineChart, { feesData: _ctx.soluliveFeesDataForChart }, null, 8, ["feesData"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.soluliveGrossMarginForChart && Object.keys(_ctx.soluliveGrossMarginForChart).length > 0 && _ctx.displayChart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("p", null, "Total de marge brut : " + _toDisplayString(_ctx.totalGrossMargin) + " €", 1),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_soluliveGrossMarginBarChart, { feesData: _ctx.soluliveGrossMarginForChart }, null, 8, ["feesData"]),
            _createVNode(_component_soluliveGrossMarginLineChart, { feesData: _ctx.soluliveGrossMarginForChart }, null, 8, ["feesData"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}